{
    "i7Sda5GjBev4PtAJ0Oxp4": {
        "position": {
            "x": 16,
            "y": 10,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "decalImageKey": "blue-shield",
        "maxhealth": 50,
        "affiliation": "neutral",
        "key": "i7Sda5GjBev4PtAJ0Oxp4",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "bpPvwr9_RP6QnSb4GJfn7": {
        "position": {
            "x": 19,
            "y": 11,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "decalImageKey": "blue-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "neutral",
        "key": "bpPvwr9_RP6QnSb4GJfn7",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "-l-J01lhPgOfkLu2z2_of": {
        "position": {
            "x": 18,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "decalImageKey": "blue-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "neutral",
        "key": "-l-J01lhPgOfkLu2z2_of",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "jLi-2-HrRw5XOE02iqPCR": {
        "position": {
            "x": 17,
            "y": 12,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "decalImageKey": "red-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "bad",
        "key": "jLi-2-HrRw5XOE02iqPCR",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "WqUBffnHhBKKDMsimkKB9": {
        "position": {
            "x": 15,
            "y": 12,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "WqUBffnHhBKKDMsimkKB9"
    },
    "okiYpanputtFIg7IcljrR": {
        "position": {
            "x": 15,
            "y": 13,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "okiYpanputtFIg7IcljrR"
    },
    "nal03w110NB774yzGyqom": {
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "nal03w110NB774yzGyqom"
    },
    "WtWyLVedRZP0bGCHevigY": {
        "position": {
            "x": 15,
            "y": 15,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "WtWyLVedRZP0bGCHevigY"
    },
    "pVYxTPJfwG_mK2twRtWy8": {
        "position": {
            "x": 17,
            "y": 15,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "pVYxTPJfwG_mK2twRtWy8"
    },
    "5dGMwftlmzGNql3mn2wcV": {
        "position": {
            "x": 16,
            "y": 15,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "5dGMwftlmzGNql3mn2wcV"
    },
    "tripjiwkn0XaD5l36SMOu": {
        "position": {
            "x": 14,
            "y": 15,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "tripjiwkn0XaD5l36SMOu"
    },
    "pv4yih6pRDfDWR879Bp1x": {
        "position": {
            "x": 14,
            "y": 16,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "pv4yih6pRDfDWR879Bp1x"
    },
    "E4BYjVZ8acMXmPCHyaO2Q": {
        "position": {
            "x": 14,
            "y": 17,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "E4BYjVZ8acMXmPCHyaO2Q"
    },
    "BRyVSxd7T9WS21rwrKMjx": {
        "position": {
            "x": 12,
            "y": 17,
            "z": 1
        },
        "templateKey": "jobs/hammerknight",
        "jobKey": "hammerknight",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "bad",
        "key": "BRyVSxd7T9WS21rwrKMjx",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "QwvIyMZd3S6YLS2g9KsLs": {
        "position": {
            "x": 12,
            "y": 15,
            "z": 1
        },
        "templateKey": "jobs/spearcavalier",
        "jobKey": "spearcavalier",
        "maxhealth": 50,
        "affiliation": "bad",
        "key": "QwvIyMZd3S6YLS2g9KsLs",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "jlwFPx8vWyfVr0oI_ygS4": {
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "decalImageKey": "blue-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "bad",
        "key": "jlwFPx8vWyfVr0oI_ygS4",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "4ClLWxAgEnpIMNzuz8TVl": {
        "position": {
            "x": 17,
            "y": 17,
            "z": 1
        },
        "templateKey": "jobs/hammer",
        "jobKey": "hammer",
        "decalImageKey": "green-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "neutral",
        "key": "4ClLWxAgEnpIMNzuz8TVl",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "4VrdatWPz8095BU46P2ht": {
        "position": {
            "x": 15,
            "y": 19,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "decalImageKey": "red-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "bad",
        "key": "4VrdatWPz8095BU46P2ht",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "xC0uYgLP2vvbB9c6s1bTA": {
        "position": {
            "x": 17,
            "y": 18,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "decalImageKey": "blue-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "neutral",
        "key": "xC0uYgLP2vvbB9c6s1bTA",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "JNINN91YtxFsK0A2J6jfN": {
        "position": {
            "x": 15,
            "y": 17,
            "z": 1
        },
        "templateKey": "jobs/spear",
        "jobKey": "spear",
        "decalImageKey": "blue-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "bad",
        "key": "JNINN91YtxFsK0A2J6jfN",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "QZfGFG9HfxZJu5CR4h0Tj": {
        "position": {
            "x": 17,
            "y": 16,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "decalImageKey": "red-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "neutral",
        "key": "QZfGFG9HfxZJu5CR4h0Tj",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "YEyB5rGY14xHoIICfXSXy": {
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "decalImageKey": "blue-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "neutral",
        "key": "YEyB5rGY14xHoIICfXSXy",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "Pr9k7rY_qHQjOj8qWD99z": {
        "position": {
            "x": 14,
            "y": 12,
            "z": 1
        },
        "templateKey": "jobs/spear",
        "jobKey": "spear",
        "decalImageKey": "blue-shield",
        "maxhealth": 50,
        "moverange": 1,
        "affiliation": "bad",
        "key": "Pr9k7rY_qHQjOj8qWD99z",
        "properties": [
            "can be pacified"
        ],
        "ai": {
            "behaviors": [
                "non-player-enemies first"
            ]
        }
    },
    "qpXlYqJDlpqD_KGtdAnY8": {
        "position": {
            "x": 10,
            "y": 13,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "qpXlYqJDlpqD_KGtdAnY8"
    },
    "fP3LSA5al5eYoQH1GhQuq": {
        "position": {
            "x": 10,
            "y": 12,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "fP3LSA5al5eYoQH1GhQuq"
    },
    "QYd5jUUjSa2EiT3q0UpLV": {
        "position": {
            "x": 10,
            "y": 14,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "QYd5jUUjSa2EiT3q0UpLV"
    },
    "priestess": {
        "position": {
            "x": 11,
            "y": 13,
            "z": 1
        },
        "templateKey": "jobs/priest",
        "jobKey": "priest",
        "affiliation": "good",
        "key": "priestess",
        "maxhealth": 40,
        "skills": [
            "restore-health"
        ],
        "properties": [
            "canPacify"
        ]
    }
}
